<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="formData"
      ref="detailInfo"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card" v-model="selectLang">
        <el-tab-pane
          :name="item.langCode"
          :label="$t('message.' + item.langCode)"
          v-for="(item, index) in formData.langMaps"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Status </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="status"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-select v-model="formData.status">
                      <el-option
                        v-for="item in [
                          { val: 1, text: 'Active' },
                          { val: 0, text: 'Disable' },
                        ]"
                        :key="item.val"
                        :label="item.text"
                        :value="item.val"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Content </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMaps.' + index + '.content'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <ckeditor
                      class="custom-ckeditor"
                      :editor="editor"
                      @ready="editorOnReady"
                      v-model="item.content"
                      :config="editorConfig"
                    ></ckeditor>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button @click="handleSubmit" type="primary"
                      >Save</el-button
                    >
                    <el-button @click="handleBack">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import config from "../config";
import axios from "axios";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      formData: {
        status: 1,
        langMaps: [
          {
            content: "",
            langCode: "en_US",
          },
          {
            content: "",
            langCode: "zh_CN",
          },
          {
            content: "",
            langCode: "zh_HK",
          },
        ],
      },
      selectLang: "en_US",
      editor:ClassicEditor,

    };
  },
  computed: {
    editorConfig(){
      return {
        toolbar: [
          "Heading",
          "bold",
          "italic",
          "underline",
          "Link",
          "bulletedList",
          "numberedList",
          "fontfamily",
          "fontsize",
          "alignment",
          "outdent",
          "indent",
          "undo",
          "redo"
        ]
      }
    },
    baseURL() {
      return config.domain + "/";
    },
    userInfo() {
      return this.getAuthObj();
    },
  },

  created() {
    this.intiPage();
  },
  mounted() {},
  methods: {
    async intiPage() {
      const param = {
        ...this.userInfo,
      };
      const {
        data: { result, status_code, status_message },
      } = await axios.post(this.baseURL + "awardsList/list", param);
      if (status_code == "0") {
        this.formData = result;
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    editorOnReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    async handleSubmit() {
      this.$refs["detailInfo"].validate(async (valid) => {
        if (valid) {
          const param = {
            ...this.formData,
            ...this.userInfo,
          };
          const {
            data: { status_code, status_message },
          } = await axios.post(this.baseURL + "awardsList/update", param);
          if (status_code == "0") {
          } else {
            this.$store.getters.warning.warningMsg = status_message;
            this.$store.getters.warning.warningFalg = true;
          }
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss">
.custom-ckeditor{
  figure {
    table {
      border:none !important;
      tbody {
        tr {
          td{
            border:none !important;
          }
        }
      }
    }
  }
  u {
    overflow: hidden;
    white-space:nowrap;
  }
}
</style>
